var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.995
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 3.035)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.453,15.931H1.547A1.525,1.525,0,0,1,0,14.432V1.5A1.525,1.525,0,0,1,1.547,0h18.9A1.53,1.53,0,0,1,22,1.5V14.432A1.525,1.525,0,0,1,20.453,15.931ZM1.547,6.007v8.425h18.9V6.007Zm0-4.508V4.008h18.9V1.5ZM8.669,11.963a.917.917,0,1,1,.945-.916A.932.932,0,0,1,8.669,11.963Zm-3.577,0a.917.917,0,1,1,.945-.916A.932.932,0,0,1,5.092,11.963Z",
  transform: "translate(0 0)"
})))));
export default __webpack_public_path__ + "static/media/preparing_order.1ad7090e.svg";
export { SvgComponent as ReactComponent };